import Installation from "../";

const routes = [{ name: "InstallationPage", path: "/installation", component: Installation.InstallationPage, meta: { title: "Installazione Piattaforma" } }];

export default routes;
